import React, { useState, useEffect } from 'react';
import './Greeting.css';

const messages = [
  'Namaste 🙏',
  'Welcome to my profile!',
  'Glad to see you here!',
  'Explore my work 👇',
];

const Greeting = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % messages.length);
    }, 3000); // change message every 3 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="greeting-button">
      <span className="greeting-text">{messages[index]}</span>
      <span className="cursor">|</span>
    </div>
  );
};

export default Greeting;